import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import MomentRow from '../components/MomentRow';
import OpportunityCard from '../components/OpportunityCard';
import SectionTitle from '../components/SectionTitle';

// Each section wraps its title together with the first item inside a
// wrap={false} View — that pair acts as a single unit that can't break across
// pages, so the title can never be orphaned at the bottom of a page.
// Subsequent items flow freely and can break between cards.

export const KeyMomentsSection = ({ report }) => {
  const moments = report.moments || [];
  if (!moments.length) return null;
  return (
    <View>
      <View wrap={false}>
        <SectionTitle>Key Moments</SectionTitle>
        <MomentRow moment={moments[0]} isLast={moments.length === 1} />
      </View>
      {moments.slice(1).map((m, i, arr) => (
        <MomentRow key={i + 1} moment={m} isLast={i === arr.length - 1} />
      ))}
    </View>
  );
};

export const OpportunitiesSection = ({ report }) => {
  const opps = report.opportunities || [];
  if (!opps.length) return null;
  return (
    <View>
      <View wrap={false}>
        <SectionTitle>Opportunities</SectionTitle>
        <OpportunityCard opportunity={opps[0]} />
      </View>
      {opps.slice(1).map((o, i) => (
        <View key={i + 1} style={{ marginTop: space.md }}>
          <OpportunityCard opportunity={o} />
        </View>
      ))}
    </View>
  );
};

const DealIntelligenceSection = ({ report }) => (
  <>
    <KeyMomentsSection report={report} />
    <View style={{ height: space.md }} />
    <OpportunitiesSection report={report} />
  </>
);

export default DealIntelligenceSection;
